import SoftBox from "components/SoftBox";
import Table from "examples/Tables/Table";
import TableData from "./data/index";
import { Pagination, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { baseURL } from "utils/api";
import AddressForm from "./form/index";
import SoftButton from "components/SoftButton";
import SoftTypography from "components/SoftTypography";


function index() {

  const [data, setData] = useState([])
  const { columns, rows } = data;
  const id = localStorage.getItem('id');
  const [totalPage, setTotalPage] = useState(1);
  const [page, setPage] = useState(1);
  const [addressId, setAddressId] = useState('')
  const [show, setShow] = useState(false);

 
  const handlePageChange = (page) => {
    setPage(page);
  }

  return (
    <SoftBox mb={3}>
      <SoftBox sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: 2,
      }}>
        <SoftTypography variant="h5" gutterBottom>
          Additional Locations
        </SoftTypography>
        <SoftButton
          onClick={() => setShow(!show)}
          variant="outlined"
          color="info"
          size="small"
        >
          + Add Address
        </SoftButton>
      </SoftBox>
      <AddressForm show={show} unShow={setShow} addressId={addressId} />
      {/* <Card className="glassmorphism-card"> */}
      <SoftBox
        sx={{
          "& .MuiTableRow-root:not(:last-child)": {
            "& td": {
              borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                `${borderWidth[1]} solid ${borderColor}`,
            },
          },
        }}
      >
        <Table columns={columns} rows={rows} />
      </SoftBox>

      <Stack spacing={5} m={5} sx={{ display: "flex", alignItems: 'center', justifyContent: "center" }}>
        <Pagination
          onChange={(event, page) => handlePageChange(page)}
          count={totalPage}
          variant="outlined"
          sx={{
            '& .MuiPaginationItem-root': {
              color: 'gray', // Inactive color
              borderColor: "gray"
            },
            '& .Mui-selected': {
              color: '#ffffff', // Active color
              borderColor: "#ffffff",
            },
          }}
          shape="rounded"

        />
      </Stack>
      {/* </Card> */}
    </SoftBox>

  );
}

export default index;



